<template>
  <div>
    <Tables
      ref="tableGrid"
      :columns="['Nome', 'CPF/CNPJ', 'Último Contato', 'Evento Utilizado', 'Telefone', 'Oportunidades']"
      :showTipFooter="false"
      :showReload="true"
      @Load="onLoadContacts"
      @Reload="reload"
    >
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.nome ? obj.nome : ''"
                     @Edit="openAssociatePage(obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.document ? obj.document : ''"
                     @Edit="openAssociatePage(obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.ultimoContato ? moment.tz(obj.ultimoContato, 'America/Sao_Paulo').format('DD/MM/YYYY').toString() : 'Não realizado'"
                     @Edit="openAssociatePage(obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.eventoUtilizado ? obj.eventoUtilizado : 'Não realizado'"
                     @Edit="openAssociatePage(obj.idAssociado)"/>
        <TableColumn :IsText="true" :status="1" :value="obj.telefone ? obj.telefone : ''"
                     @Edit="openAssociatePage(obj.idAssociado)"/>
        <td class="row justify-content-around">
          <div style="display: flex; justify-content: center; align-items: center;">
            <i
              class="fa fa-address-card cursor-pointer mt-1"
              style="color: black; font-size: 1.1rem"
              :title="'Oportunidades'"
              @click="openOportunityModal(obj)"
            ></i>
          </div>
        </td>
      </tr>
    </Tables>
    <OportunityModal ref="OportunityModal" v-if="selectedObj"/>
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import OportunityModal from '@/views/private/StartPage/modal/OportunityModal.vue'

import { loading } from '@/shared/utils/UIHelper'

export default {
  name: 'BirthdayTable',
  mixins: [ActionsForm],
  components: {
    OportunityModal
  },
  data () {
    return {
      selectedObj: null
    }
  },
  props: {
    orderBy: {
      type: String,
      default: 'ASC'
    }
  },
  methods: {
    async onLoad () {
      await this.onLoadContacts()
    },
    async reload () {
      loading.push()
      await this.onLoadContacts()
      loading.pop()
    },
    async onLoadContacts () {
      const response = await PersonRepository.GetContactsPaging(this.orderBy, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
      this.onResultGrid(response)
    },
    openAssociatePage (associateId) {
      this.$router.replace({
        name: 'DetalhesAssociate',
        params: {
          associateId: associateId,
          backUrl: 'Associate'
        }
      })
    },
    openOportunityModal (obj) {
      this.selectedObj = obj
      this.$nextTick(() => {
        this.$refs.OportunityModal.showModal(obj)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/StartPage/ContactedTable.vue